import { Injectable, Inject } from '@nestjs/common';
import { PostActivityEntity } from './post-activity.entity';
import { Repository, Raw, getConnection } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { PostActivityDTO} from './dto/post-activity.dto';
import { PostActivityResponseModel,   } from './dto/post-activity-response.model';
import { ErrorResponse } from '@gtpl/shared-models/common-models';

@Injectable()
export class PostActivityService {
    constructor(
        @InjectRepository(PostActivityEntity)
        private postActivityRepository : Repository<PostActivityEntity>,
    ) {}
    
    async createPostActivity(postActivityDto: PostActivityDTO, request: Request): Promise<PostActivityResponseModel>{
        const response = new PostActivityResponseModel();
        try {             
            const PostActivityEntityExists = await this.getPostActivitywithoutRealtions(postActivityDto.postId,postActivityDto.userId);
            if (PostActivityEntityExists) {
                if(postActivityDto.like!=null) {
                    console.log("hiii",PostActivityEntityExists)                      
                    if(postActivityDto.like == true) {
                        postActivityDto.like = true;
                        postActivityDto.dislike = false;
                    }else {
                        postActivityDto.like = false;
                        postActivityDto.dislike = false;
                    }
                    const updateActivity = await this.postActivityRepository.update(PostActivityEntityExists.Id,postActivityDto);
                    if(updateActivity){
                        const updatedData = await this.postActivityRepository.findOne({
                            //relations:['post'],
                            where:{Id:PostActivityEntityExists.Id}
                        });
                        response.status = true;
                        response.data = updatedData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Post liked successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse (99998,'like not update')
                    }
                } else if(postActivityDto.dislike!=null){
                    if(postActivityDto.dislike == true) {
                        postActivityDto.like = false;
                        postActivityDto.dislike = true;
                    } else {
                        postActivityDto.like = false;
                        postActivityDto.dislike = false;
                    }                       
                    const updateActivity = await this.postActivityRepository.update(PostActivityEntityExists.Id,postActivityDto);
                    if(updateActivity){
                        const updatedData = await this.postActivityRepository.findOne({
                            //relations:['post'],
                            where:{Id:PostActivityEntityExists.Id}
                        });
                        response.status = true;
                        response.data = updatedData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Post disliked successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse (99998,'Dislike not updated')
                    }
                } else if(postActivityDto.fev!=null) {                       
                    if(postActivityDto.fev == true) {
                        postActivityDto.fev = false;                        
                    } else {
                        postActivityDto.fev = true;
                    }
                    const updateActivity = await this.postActivityRepository.update(PostActivityEntityExists.Id,postActivityDto);
                    if(updateActivity){
                        const updatedData = await this.postActivityRepository.findOne({
                            //relations:['post'],
                            where:{Id:PostActivityEntityExists.Id}
                        });
                        response.status = true;
                        response.data = updatedData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Post favourite successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse (99998,'Favourite not updated')
                    }
                } else {                        
                    if(PostActivityEntityExists.shared == null || PostActivityEntityExists.shared < 1){
                        postActivityDto.shared=postActivityDto.shared;
                    } else {
                        postActivityDto.shared=PostActivityEntityExists.shared+postActivityDto.shared;
                    }
                    const updateActivity = await this.postActivityRepository.update(PostActivityEntityExists.Id,postActivityDto);
                    if(updateActivity){
                        const updatedData = await this.postActivityRepository.findOne({
                            //relations:['post'],
                            where:{Id:PostActivityEntityExists.Id}
                        });
                        response.status = true;
                        response.data = updatedData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Post shared successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse (99998,'shared failed')
                    }
                }
            } else {
                const savedPostActivty = await this.postActivityRepository.save(postActivityDto);
                if(savedPostActivty){
                    response.status = true;
                    response.data = savedPostActivty;
                    response.statusCode = 50000;
                    if(postActivityDto.like) response.internalMessage = 'Post liked successfully';
                    if(postActivityDto.dislike) response.internalMessage = 'Post disliked successfully';
                    if(postActivityDto.shared) response.internalMessage = 'Post shared successfully';
                    response.intlCode = 11100;
                } else {
                    if(postActivityDto.like) {
                        throw new ErrorResponse (11106,'Post like failed ');
                    } else if(postActivityDto.dislike) {
                        throw new ErrorResponse (11106,'Post dislike failed ');
                    } else {
                        throw new ErrorResponse (11106,'Post share failed ');
                    }                            
                }
            }                                                           
            return response;
        } catch (error) { 
            throw error;
        } 
    }
    
    async getPostActivitywithoutRealtions(postId: number,userId: number) : Promise<PostActivityEntity>{
        const PostActivityResponse = await this.postActivityRepository.findOne({
            where: {postId:postId ,userId:  userId, status: true},
        });
        if (PostActivityResponse) {
            return PostActivityResponse;
        } else{
            return null;
        }
    }

     async getPostLikDisLikFavCount(postId) {
        try {
            const postActCount = await getConnection()
            .createQueryBuilder()
            .select("Sum(IF(like_status = true, 1, 0)) as likeCount,Sum(IF(dislike = true, 1, 0)) as dislikeCount,Sum(IF(fev = true, 1, 0)) as fevCount")
            .from(PostActivityEntity, "PostActivity")
            .where('post_id=:da', { da: postId })
            .orderBy('created_at','ASC')
            .getRawOne();
            if (postActCount) {
              return postActCount;
            } else {
              return null;
            }
        } catch (err) {
          throw err;
        }
     }

    async getPostLikDisLikFavStatus(postId,userId) {
        try {
            const postAct = await this.postActivityRepository.findOne({
                where:{postId:postId, userId:userId}
            })
            if(postAct) {
                return postAct;
            } else {
                return null;
            }
        } catch (error) {
            throw error;
        }
    }
     
}



























































